import { render, staticRenderFns } from "./AutoTraderModal.vue?vue&type=template&id=a5b2094a&scoped=true"
import script from "./AutoTraderModal.vue?vue&type=script&lang=js"
export * from "./AutoTraderModal.vue?vue&type=script&lang=js"
import style0 from "./AutoTraderModal.vue?vue&type=style&index=0&id=a5b2094a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5b2094a",
  null
  
)

export default component.exports